import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { Stage, Layer, Image as KonvaImage, Rect, Transformer } from 'react-konva';
import {
  AlignCenter,
  AlignHorizontalJustifyCenter,
  AlignVerticalJustifyCenter,
  ArrowLeft,
  CornerUpRight,
  Save,
  Trash2,
  Upload,
} from 'lucide-react';

const DEFAULT_PAGE_SIZE = { width: 1600, height: 2000 };
const NUMBER_ASSET_SIZE = 512;
const DEFAULT_MARGIN = 80;
const DEFAULT_STAGE_SCALE = 0.3;

const createId = (prefix) =>
  `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

const FUTURA_NUMBER_PATHS = {
  0: ['M112.11959287531809 256.0Q112.11959287531809 221.53435114503816 120.0521628498728 186.24809160305344Q127.98473282442751 150.96183206106872 143.84987277353693 117.31679389312978Q159.71501272264635 83.67175572519085 188.98346055979647 62.335877862595424Q218.2519083969466 41.0 256.0 41.0Q293.74809160305347 41.0 323.0165394402036 62.335877862595424Q352.2849872773537 83.67175572519085 368.15012722646316 117.31679389312978Q384.01526717557255 150.96183206106872 391.94783715012727 186.24809160305344Q399.88040712468194 221.53435114503816 399.88040712468194 256.0Q399.88040712468194 282.80661577608146 395.23027989821884 310.98091603053433Q390.58015267175574 339.15521628498726 379.63867684478373 368.1501272264631Q368.6972010178117 397.14503816793894 352.558524173028 419.5750636132316Q336.41984732824426 442.00508905852416 311.52798982188295 456.5025445292621Q286.63613231552165 471.0 256.0 471.0Q225.3638676844784 471.0 200.47201017811707 456.5025445292621Q175.58015267175574 442.00508905852416 159.44147582697204 419.5750636132316Q143.30279898218834 397.14503816793894 132.36132315521633 368.1501272264631Q121.4198473282443 339.15521628498726 116.76972010178119 310.98091603053433Q112.11959287531809 282.80661577608146 112.11959287531809 256.0ZM301.68066157760813 103.09287531806615Q282.25954198473283 84.76590330788804 256.0 84.76590330788804Q229.7404580152672 84.76590330788804 210.31933842239187 103.09287531806615Q190.89821882951657 121.41984732824426 180.77735368956746 149.3206106870229Q170.65648854961836 177.22137404580155 166.00636132315526 204.30152671755727Q161.35623409669213 231.38167938931298 161.35623409669213 255.4529262086514Q161.35623409669213 279.52417302798983 166.00636132315526 306.33078880407123Q170.65648854961836 333.13740458015263 180.77735368956746 361.0381679389313Q190.89821882951657 388.9389312977099 210.31933842239187 406.99236641221376Q229.7404580152672 425.0458015267175 256.0 425.0458015267175Q282.25954198473283 425.0458015267175 301.68066157760813 406.99236641221376Q321.1017811704835 388.9389312977099 331.2226463104326 361.0381679389313Q341.3435114503817 333.13740458015263 345.9936386768448 306.33078880407123Q350.6437659033079 279.52417302798983 350.6437659033079 255.4529262086514Q350.6437659033079 231.38167938931298 345.9936386768448 204.30152671755727Q341.3435114503817 177.22137404580155 331.2226463104326 149.3206106870229Q321.1017811704835 121.41984732824426 301.68066157760813 103.09287531806615Z'],
  1: ['M267.69098143236073 90.0450928381963H192.98275862068965L222.63793103448273 41.0H319.01724137931035V471.0H267.69098143236073Z'],
  2: ['M222.21428571428572 422.97402597402595H391.9805194805195V471.0H120.01948051948054L304.3051948051948 244.83116883116884Q341.7207792207792 199.03896103896108 341.7207792207792 169.44155844155847Q341.7207792207792 136.49350649350652 316.87012987012986 112.75974025974028Q292.0194805194805 89.02597402597405 259.07142857142856 89.02597402597405Q227.24025974025977 89.02597402597405 203.7857142857143 111.64285714285717Q180.33116883116884 134.25974025974028 178.0974025974026 166.09090909090912H125.60389610389612Q131.74675324675326 109.12987012987014 167.20779220779224 75.06493506493507Q202.6688311688312 41.0 259.07142857142856 41.0Q313.7987012987013 41.0 352.8896103896104 77.01948051948054Q391.9805194805195 113.03896103896108 391.9805194805195 167.20779220779224Q391.9805194805195 215.23376623376626 360.70779220779224 253.76623376623377Z'],
  3: ['M248.6145038167939 265.3002544529262V222.62849872773538Q329.5814249363868 222.62849872773538 329.5814249363868 156.43256997455472Q329.5814249363868 125.24936386768451 309.3396946564886 105.55470737913487Q289.09796437659037 85.86005089058523 257.9147582697201 85.86005089058523Q230.0139949109415 85.86005089058523 211.96055979643768 101.99872773536896Q193.90712468193385 118.13740458015269 189.53053435114506 144.9440203562341H138.6526717557252Q145.76463104325703 94.06615776081424 177.22137404580155 67.53307888040712Q208.67811704834605 41.0 259.5559796437659 41.0Q310.43384223918576 41.0 344.6259541984733 71.36259541984734Q378.8180661577608 101.72519083969468 378.8180661577608 152.0559796437659Q378.8180661577608 215.51653944020356 326.29898218829516 245.058524173028Q384.8358778625954 272.9592875318066 384.8358778625954 347.36132315521627Q384.8358778625954 403.70992366412213 347.36132315521627 437.35496183206106Q309.88676844783714 471.0 252.99109414758271 471.0Q202.66030534351148 471.0 166.00636132315526 440.36386768447835Q129.352417302799 409.7277353689567 127.1641221374046 360.49109414758266H176.94783715012724Q180.77735368956746 390.0330788804071 203.4809160305344 408.0865139949109Q226.1844783715013 426.1399491094147 256.8206106870229 426.1399491094147Q290.7391857506361 426.1399491094147 313.1692111959287 402.6157760814249Q335.59923664122135 379.0916030534351 335.59923664122135 345.1730279898219Q335.59923664122135 306.33078880407123 311.2544529262086 284.4478371501272Q286.90966921119593 262.5648854961832 248.6145038167939 265.3002544529262Z'],
  4: ['M358.84987277353684 365.9618320610687H405.8982188295165V410.82188295165395H358.84987277353684V471.0H309.61323155216286V410.82188295165395H106.10178117048346L358.84987277353684 41.00000000000006ZM309.61323155216286 365.9618320610687V195.82188295165395H308.5190839694656L192.53944020356232 365.9618320610687Z'],
  5: ['M391.9805194805195 89.025974025974H259.62987012987014L233.38311688311688 175.58441558441552L262.9805194805195 173.90909090909088Q322.1753246753247 173.90909090909088 360.1493506493507 217.46753246753244Q398.12337662337666 261.025974025974 398.12337662337666 321.3376623376623Q398.12337662337666 387.2337662337662 353.16883116883116 429.11688311688306Q308.2142857142857 470.99999999999994 242.3181818181818 470.99999999999994Q202.66883116883116 470.99999999999994 167.2077922077922 451.17532467532465Q131.74675324675326 431.3506493506493 113.8766233766234 397.2857142857142L152.9675324675325 360.4285714285714Q162.46103896103898 386.67532467532465 190.10389610389612 404.8246753246753Q217.74675324675326 422.97402597402595 246.22727272727275 422.97402597402595Q288.66883116883116 422.97402597402595 318.26623376623377 392.538961038961Q347.8636363636364 362.1038961038961 347.8636363636364 319.6623376623376Q347.8636363636364 278.89610389610385 317.98701298701303 249.29870129870125Q288.11038961038963 219.70129870129867 247.34415584415586 219.70129870129867Q225.0064935064935 219.70129870129867 203.50649350649354 229.7532467532467Q182.00649350649354 239.80519480519476 168.60389610389612 257.11688311688306H158.55194805194807L223.33116883116884 41.0H391.9805194805195Z'],
  6: ['M304.6895674300255 41.0 341.89058524173026 66.16539440203564 231.92875318066157 214.96946564885496 233.02290076335876 216.06361323155215Q252.7175572519084 206.21628498727733 273.5063613231552 206.21628498727733Q323.29007633587787 206.21628498727733 358.029262086514 245.33206106870227Q392.7684478371501 284.4478371501272 392.7684478371501 335.32569974554707Q392.7684478371501 391.67430025445293 352.8320610687023 431.33715012722644Q312.8956743002544 471.0 256.54707379134857 471.0Q202.38676844783714 471.0 160.8091603053435 431.88422391857506Q119.23155216284988 392.7684478371501 119.23155216284988 339.15521628498726Q119.23155216284988 290.46564885496184 164.0916030534351 230.2875318066158ZM256.0 425.0458015267175Q291.0127226463104 425.0458015267175 317.27226463104324 399.88040712468194Q343.5318066157761 374.7150127226463 343.5318066157761 340.7964376590331Q343.5318066157761 303.59541984732823 316.7251908396946 277.882951653944Q289.9185750636132 252.1704834605598 256.0 252.1704834605598Q222.08142493638678 252.1704834605598 195.27480916030535 278.43002544529264Q168.46819338422392 304.6895674300255 168.46819338422392 338.0610687022901Q168.46819338422392 373.6208651399491 194.45419847328245 399.3333333333333Q220.44020356234097 425.0458015267175 256.0 425.0458015267175Z'],
  7: ['M322.17532467532465 89.025974025974H104.38311688311688V41.0H407.61688311688306L145.14935064935065 470.99999999999994L104.38311688311688 445.8701298701298Z'],
  8: ['M176.12722646310434 347.36132315521627Q176.12722646310434 377.9974554707379 200.74554707379136 401.52162849872775Q225.36386768447838 425.0458015267175 256.0 425.0458015267175Q286.63613231552165 425.0458015267175 311.25445292620867 401.52162849872775Q335.8727735368957 377.9974554707379 335.8727735368957 347.36132315521627Q335.8727735368957 315.0839694656488 311.8015267175573 292.38040712468194Q287.73027989821884 269.676844783715 256.0 269.676844783715Q224.26972010178116 269.676844783715 200.19847328244276 292.38040712468194Q176.12722646310434 315.0839694656488 176.12722646310434 347.36132315521627ZM126.89058524173029 347.36132315521627Q126.89058524173029 312.8956743002544 143.8498727735369 286.089058524173Q160.80916030534354 259.2824427480916 191.99236641221376 248.3409669211196Q137.8320610687023 217.70483460559797 137.8320610687023 155.8854961832061Q137.8320610687023 106.10178117048349 172.02417302798983 73.55089058524175Q206.21628498727736 41.0 256.0 41.0Q305.78371501272267 41.0 339.97582697201017 73.55089058524175Q374.1679389312977 106.10178117048349 374.1679389312977 155.8854961832061Q374.1679389312977 217.70483460559797 320.00763358778624 248.3409669211196Q351.19083969465646 259.2824427480916 368.1501272264631 286.089058524173Q385.10941475826974 312.8956743002544 385.10941475826974 347.36132315521627Q385.10941475826974 403.1628498727735 347.63486005089055 437.0814249363867Q310.1603053435114 471.0 256.0 471.0Q201.83969465648858 471.0 164.36513994910945 437.0814249363867Q126.89058524173029 403.1628498727735 126.89058524173029 347.36132315521627ZM185.97455470737913 155.8854961832061Q185.97455470737913 180.50381679389312 208.13104325699746 203.20737913486005Q230.2875318066158 225.91094147582697 256.0 225.91094147582697Q281.7124681933842 225.91094147582697 303.8689567430025 203.20737913486005Q326.0254452926209 180.50381679389312 326.0254452926209 155.8854961832061Q326.0254452926209 126.3435114503817 304.96310432569976 105.55470737913487Q283.90076335877865 84.76590330788804 256.0 84.76590330788804Q228.09923664122135 84.76590330788804 207.03689567430024 105.55470737913487Q185.97455470737913 126.3435114503817 185.97455470737913 155.8854961832061Z'],
  9: ['M207.31043256997455 471.0 170.10941475826974 445.28753180661573 280.0712468193384 297.03053435114504 278.9770992366412 295.93638676844785Q263.6590330788804 303.59541984732823 239.04071246819336 303.59541984732823Q188.70992366412213 303.59541984732823 153.970737913486 265.3002544529262Q119.23155216284988 227.00508905852416 119.23155216284988 176.67430025445293Q119.23155216284988 120.32569974554707 159.16793893129773 80.66284987277353Q199.10432569974554 41.0 255.45292620865138 41.0Q309.61323155216286 41.0 351.19083969465646 80.11577608142494Q392.7684478371501 119.23155216284988 392.7684478371501 172.84478371501274Q392.7684478371501 221.53435114503816 347.9083969465649 281.7124681933842ZM256.0 259.8295165394402Q294.29516539440203 259.8295165394402 318.91348600508906 234.11704834605598Q343.5318066157761 208.40458015267177 343.5318066157761 173.3918575063613Q343.5318066157761 140.0203562340967 318.09287531806615 113.48727735368959Q292.6539440203562 86.95419847328247 259.28244274809157 86.95419847328247Q222.08142493638678 86.95419847328247 195.27480916030535 112.66666666666669Q168.46819338422392 138.3791348600509 168.46819338422392 173.3918575063613Q168.46819338422392 208.95165394402036 195.54834605597964 234.39058524173026Q222.62849872773535 259.8295165394402 256.0 259.8295165394402Z'],
  10: ['M103.81219272369715 138.68436578171094H51.0L71.96361848574237 104.01376597836781H140.0953785644051V407.9862340216323H103.81219272369715Z', 'M248.944936086529 256.00000000000006Q248.944936086529 230.60176991150448 254.7905604719764 204.5988200589971Q260.6361848574238 178.5958702064897 272.3274336283186 153.80235988200593Q284.0186823992134 129.00884955752218 305.58702064896755 113.28613569321539Q327.1553588987217 97.56342182890859 354.9724680432645 97.56342182890859Q382.78957718780725 97.56342182890859 404.3579154375615 113.28613569321539Q425.92625368731564 129.00884955752218 437.6175024582104 153.80235988200593Q449.3087512291052 178.5958702064897 455.1543756145526 204.5988200589971Q461.0 230.60176991150448 461.0 256.00000000000006Q461.0 275.75417895771886 457.5732546705998 296.5162241887906Q454.1465093411996 317.2782694198624 446.0835791543756 338.64503441494594Q438.02064896755167 360.01179941002954 426.12782694198626 376.5408062930187Q414.23500491642085 393.0698131760079 395.89183874139627 403.7531956735497Q377.5486725663717 414.43657817109147 354.9724680432645 414.43657817109147Q332.39626352015733 414.43657817109147 314.05309734513276 403.7531956735497Q295.7099311701082 393.0698131760079 283.81710914454277 376.5408062930187Q271.9242871189774 360.01179941002954 263.8613569321534 338.64503441494594Q255.7984267453294 317.2782694198624 252.3716814159292 296.5162241887906Q248.944936086529 275.75417895771886 248.944936086529 256.00000000000006ZM388.6352015732547 143.32055063913475Q374.3235004916421 129.81514257620455 354.9724680432645 129.81514257620455Q335.6214355948869 129.81514257620455 321.3097345132743 143.32055063913475Q306.9980334316617 156.82595870206495 299.53982300884957 177.38643067846613Q292.08161258603735 197.9469026548673 288.6548672566372 217.90265486725667Q285.228121927237 237.85840707964607 285.228121927237 255.59685349065887Q285.228121927237 273.33529990167165 288.6548672566372 293.0894788593904Q292.08161258603735 312.8436578171092 299.53982300884957 333.4041297935104Q306.9980334316617 353.96460176991155 321.3097345132743 367.26843657817113Q335.6214355948869 380.5722713864307 354.9724680432645 380.5722713864307Q374.3235004916421 380.5722713864307 388.6352015732547 367.26843657817113Q402.94690265486724 353.96460176991155 410.40511307767946 333.4041297935104Q417.8633235004917 312.8436578171092 421.2900688298919 293.0894788593904Q424.716814159292 273.33529990167165 424.716814159292 255.59685349065887Q424.716814159292 237.85840707964607 421.2900688298919 217.90265486725667Q417.8633235004917 197.9469026548673 410.40511307767946 177.38643067846613Q402.94690265486724 156.82595870206495 388.6352015732547 143.32055063913475Z'],
};

const createNumberSvg = (value) => `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${NUMBER_ASSET_SIZE} ${NUMBER_ASSET_SIZE}">
  ${FUTURA_NUMBER_PATHS[value]
    .map(
      (path) => `<path d="${path}" fill="none" stroke="black" stroke-width="18" stroke-linejoin="round" />`
    )
    .join('')}
</svg>`;

export const BUILT_IN_NUMBER_ASSETS = Array.from({ length: 11 }, (_, value) => ({
  id: `number-${value}`,
  name: `${value}.svg`,
  kind: 'number',
  svgText: createNumberSvg(value),
}));

const svgToDataUrl = (svgText) =>
  `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgText)}`;

export const normalizeSvgForStroke = (svgText, strokeWidth, strokeColor = '#000000') => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(svgText, 'image/svg+xml');
  const parserError = doc.querySelector('parsererror');
  if (parserError || !doc.documentElement || doc.documentElement.tagName.toLowerCase() !== 'svg') {
    throw new Error('Invalid SVG file.');
  }

  const svg = doc.documentElement;
  if (!svg.getAttribute('viewBox')) {
    const width = parseFloat(svg.getAttribute('width')) || NUMBER_ASSET_SIZE;
    const height = parseFloat(svg.getAttribute('height')) || NUMBER_ASSET_SIZE;
    svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
  }

  svg.querySelectorAll('*').forEach((node) => {
    const tagName = node.tagName.toLowerCase();
    if (['svg', 'defs', 'title', 'desc'].includes(tagName)) return;
    if (node.getAttribute('stroke') === 'none' && node.getAttribute('fill') === 'none') return;
    node.setAttribute('fill', 'none');
    node.setAttribute('stroke', strokeColor);
    node.setAttribute('stroke-width', String(strokeWidth));
    node.setAttribute('stroke-linecap', 'round');
    node.setAttribute('stroke-linejoin', 'round');
    node.removeAttribute('style');
  });

  return new XMLSerializer().serializeToString(svg);
};

export const useSvgImage = (svgText, strokeWidth, strokeColor) => {
  const [image, setImage] = useState(null);

  useEffect(() => {
    if (!svgText) {
      setImage(null);
      return undefined;
    }

    let cancelled = false;
    const imageElement = new window.Image();
    imageElement.onload = () => {
      if (!cancelled) setImage(imageElement);
    };
    imageElement.onerror = () => {
      if (!cancelled) setImage(null);
    };

    try {
      imageElement.src = svgToDataUrl(normalizeSvgForStroke(svgText, strokeWidth, strokeColor));
    } catch (error) {
      console.error('Failed to render SVG', error);
      setImage(null);
    }

    return () => {
      cancelled = true;
    };
  }, [svgText, strokeWidth, strokeColor]);

  return image;
};

function VectorCanvasItem({ item, asset, selected, onSelect, onChange }) {
  const image = useSvgImage(asset?.svgText, item.strokeWidth || 4, item.strokeColor || '#000000');

  if (!asset || !image) return null;

  return (
    <KonvaImage
      id={`vector-${item.id}`}
      image={image}
      x={item.x}
      y={item.y}
      width={item.width}
      height={item.height}
      rotation={item.rotation || 0}
      draggable
      opacity={selected ? 0.82 : 1}
      onClick={(event) => {
        event.cancelBubble = true;
        onSelect(item.id);
      }}
      onTap={(event) => {
        event.cancelBubble = true;
        onSelect(item.id);
      }}
      onDragEnd={(event) => {
        onChange(item.id, {
          x: Math.round(event.target.x()),
          y: Math.round(event.target.y()),
          anchor: 'custom',
        });
      }}
      onTransformEnd={(event) => {
        const node = event.target;
        const nextWidth = Math.max(20, node.width() * node.scaleX());
        const nextHeight = Math.max(20, node.height() * node.scaleY());
        node.scaleX(1);
        node.scaleY(1);
        onChange(item.id, {
          x: Math.round(node.x()),
          y: Math.round(node.y()),
          width: Math.round(nextWidth),
          height: Math.round(nextHeight),
          rotation: Math.round(node.rotation()),
          anchor: 'custom',
        });
      }}
    />
  );
}

function VectorLayoutEditor() {
  const { bookId, layoutId } = useParams();
  const [bookName, setBookName] = useState('');
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [layoutName, setLayoutName] = useState('New vector layout');
  const [layouts, setLayouts] = useState([]);
  const [currentLayoutId, setCurrentLayoutId] = useState(layoutId === 'new' ? '' : layoutId || '');
  const [assets, setAssets] = useState(BUILT_IN_NUMBER_ASSETS);
  const [items, setItems] = useState([]);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [message, setMessage] = useState('');
  const stageRef = useRef(null);
  const transformerRef = useRef(null);
  const layerRef = useRef(null);

  const selectedItem = items.find((item) => item.id === selectedItemId) || null;
  const selectedAsset = selectedItem
    ? assets.find((asset) => asset.id === selectedItem.assetId)
    : null;
  const scale = DEFAULT_STAGE_SCALE;

  useEffect(() => {
    const loadBookContext = async () => {
      if (!bookId) return;
      try {
        const [bookResponse, pagesResponse, layoutsResponse] = await Promise.all([
          axios.get(`/api/book/${bookId}`, { withCredentials: true }).catch(() => null),
          axios.get(`/api/list_pages/${bookId}`, { withCredentials: true }),
          axios.get(`/api/vector-layouts?book_id=${bookId}`, { withCredentials: true }),
        ]);
        if (bookResponse?.data?.name) {
          setBookName(bookResponse.data.name);
        } else if (pagesResponse.data?.book_name) {
          setBookName(pagesResponse.data.book_name);
        }

        const firstPage = pagesResponse.data?.pages?.find((page) => page.width && page.height);
        if (firstPage) {
          setPageSize({ width: firstPage.width, height: firstPage.height });
        }

        const loadedLayouts = layoutsResponse.data?.vector_layouts || [];
        setLayouts(loadedLayouts);
        const loadedLayout = loadedLayouts.find((layout) => layout._id === currentLayoutId);
        if (loadedLayout) {
          setLayoutName(loadedLayout.name || 'Vector layout');
          setPageSize({
            width: loadedLayout.page_width || firstPage?.width || DEFAULT_PAGE_SIZE.width,
            height: loadedLayout.page_height || firstPage?.height || DEFAULT_PAGE_SIZE.height,
          });
          setAssets([...BUILT_IN_NUMBER_ASSETS, ...(loadedLayout.assets || [])]);
          setItems(loadedLayout.items || []);
        }
      } catch (error) {
        console.error('Failed to load vector layout editor context', error);
        setMessage('Failed to load book pages.');
      }
    };

    loadBookContext();
  }, [bookId, currentLayoutId]);

  useEffect(() => {
    const transformer = transformerRef.current;
    const layer = layerRef.current;
    if (!transformer || !layer || !selectedItemId) {
      transformer?.nodes([]);
      return;
    }
    const selectedNode = layer.findOne(`#vector-${selectedItemId}`);
    transformer.nodes(selectedNode ? [selectedNode] : []);
    transformer.getLayer()?.batchDraw();
  }, [items, selectedItemId]);

  const updateItem = useCallback((itemId, updates) => {
    setItems((prevItems) =>
      prevItems.map((item) =>
        item.id === itemId
          ? {
              ...item,
              ...updates,
            }
          : item,
      ),
    );
  }, []);

  const addAssetToCanvas = (asset) => {
    const size = Math.round(Math.min(pageSize.width, pageSize.height) * 0.22);
    const newItem = {
      id: createId('vector-item'),
      assetId: asset.id,
      label: asset.name.replace(/\\.svg$/i, ''),
      x: Math.round(pageSize.width / 2 - size / 2),
      y: Math.round(pageSize.height / 2 - size / 2),
      width: size,
      height: size,
      rotation: 0,
      strokeWidth: 8,
      strokeColor: '#000000',
      anchor: 'center',
      margin: DEFAULT_MARGIN,
    };
    setItems((prevItems) => [...prevItems, newItem]);
    setSelectedItemId(null);
  };

  const replaceSelectedVectorAsset = (asset) => {
    if (!selectedItem || !asset) return;
    updateItem(selectedItem.id, {
      assetId: asset.id,
      label: asset.name.replace(/\.svg$/i, ''),
    });
    setMessage('Vector replaced. Position and size kept.');
  };

  const uploadSvg = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    const svgText = await file.text();
    try {
      normalizeSvgForStroke(svgText, 4);
    } catch (error) {
      setMessage(error.message);
      event.target.value = '';
      return;
    }

    const asset = {
      id: createId('asset'),
      name: file.name,
      kind: 'uploaded',
      svgText,
    };
    setAssets((prevAssets) => [...prevAssets, asset]);
    addAssetToCanvas(asset);
    event.target.value = '';
  };

  const applyAnchor = (anchor, margin = selectedItem?.margin ?? DEFAULT_MARGIN) => {
    if (!selectedItem) return;
    const updates = { anchor, margin };
    if (anchor === 'center') {
      updates.x = Math.round(pageSize.width / 2 - selectedItem.width / 2);
      updates.y = Math.round(pageSize.height / 2 - selectedItem.height / 2);
    }
    if (anchor === 'center-x') {
      updates.x = Math.round(pageSize.width / 2 - selectedItem.width / 2);
    }
    if (anchor === 'center-y') {
      updates.y = Math.round(pageSize.height / 2 - selectedItem.height / 2);
    }
    if (anchor === 'top-left') {
      updates.x = margin;
      updates.y = margin;
    }
    if (anchor === 'top-right') {
      updates.x = Math.round(pageSize.width - selectedItem.width - margin);
      updates.y = margin;
    }
    if (anchor === 'bottom-left') {
      updates.x = margin;
      updates.y = Math.round(pageSize.height - selectedItem.height - margin);
    }
    if (anchor === 'bottom-right') {
      updates.x = Math.round(pageSize.width - selectedItem.width - margin);
      updates.y = Math.round(pageSize.height - selectedItem.height - margin);
    }
    updateItem(selectedItem.id, updates);
  };

  const deleteSelectedItem = () => {
    if (!selectedItem) return;
    setItems((prevItems) => prevItems.filter((item) => item.id !== selectedItem.id));
    setSelectedItemId(null);
    setMessage('Vector removed.');
  };

  const deleteCurrentLayout = async () => {
    if (!currentLayoutId) {
      setLayoutName('New vector layout');
      setAssets(BUILT_IN_NUMBER_ASSETS);
      setItems([]);
      setSelectedItemId(null);
      setMessage('Empty layout ready.');
      return;
    }

    const currentLayout = layouts.find((layout) => layout._id === currentLayoutId);
    if (!window.confirm(`Delete layout "${currentLayout?.name || layoutName}"?`)) return;

    try {
      await axios.delete(`/api/vector-layouts/${currentLayoutId}`, { withCredentials: true });
      setLayouts((prevLayouts) => prevLayouts.filter((layout) => layout._id !== currentLayoutId));
      setCurrentLayoutId('');
      setLayoutName('New vector layout');
      setAssets(BUILT_IN_NUMBER_ASSETS);
      setItems([]);
      setSelectedItemId(null);
      setMessage('Vector layout deleted. Empty canvas ready.');
    } catch (error) {
      console.error('Failed to delete vector layout', error);
      setMessage('Failed to delete vector layout.');
    }
  };

  const saveLayout = async ({ saveAsNew = false } = {}) => {
    let nextLayoutName = layoutName;
    if (saveAsNew || !currentLayoutId) {
      const defaultName = saveAsNew ? `${layoutName} copy` : layoutName;
      nextLayoutName = window.prompt('Vector layout name', defaultName || '');
      if (!nextLayoutName?.trim()) return;
    }

    const customAssets = assets.filter((asset) => asset.kind !== 'number');
    const payload = {
      name: nextLayoutName,
      book_id: bookId,
      page_width: pageSize.width,
      page_height: pageSize.height,
      assets: customAssets,
      items,
    };

    try {
      const response = currentLayoutId && !saveAsNew
        ? await axios.put(`/api/vector-layouts/${currentLayoutId}`, payload, { withCredentials: true })
        : await axios.post('/api/vector-layouts', payload, { withCredentials: true });
      setCurrentLayoutId(response.data._id);
      setLayoutName(response.data.name);
      setLayouts((prevLayouts) => {
        const exists = prevLayouts.some((layout) => layout._id === response.data._id);
        return exists
          ? prevLayouts.map((layout) => (layout._id === response.data._id ? response.data : layout))
          : [...prevLayouts, response.data];
      });
      setMessage(saveAsNew ? 'Vector layout saved as new.' : 'Vector layout saved.');
    } catch (error) {
      console.error('Failed to save vector layout', error);
      setMessage('Failed to save vector layout.');
    }
  };

  const loadLayout = (nextLayoutId) => {
    if (!nextLayoutId) {
      setCurrentLayoutId('');
      setLayoutName('New vector layout');
      setAssets(BUILT_IN_NUMBER_ASSETS);
      setItems([]);
      setSelectedItemId(null);
      return;
    }
    setCurrentLayoutId(nextLayoutId);
    setSelectedItemId(null);
  };

  return (
    <div className="min-h-screen bg-slate-100 px-6 py-8">
      <div className="mx-auto max-w-[1500px] space-y-4">
        <div className="flex flex-wrap items-center justify-between gap-3 rounded-xl border border-slate-200 bg-white px-4 py-3 shadow-sm">
          <div>
            <Link
              to={bookId ? `/pages/${bookId}` : '/books'}
              className="inline-flex items-center gap-1 text-xs font-medium text-slate-500 hover:text-slate-900"
            >
              <ArrowLeft size={14} />
              Back
            </Link>
            <h1 className="text-xl font-bold text-slate-950">Vector layout</h1>
            <p className="text-sm text-slate-500">
              {bookName || 'Book'} · {pageSize.width} x {pageSize.height}
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-2">
            <span className="text-xs font-semibold uppercase tracking-wide text-slate-500">
              Current layout
            </span>
            <select
              value={currentLayoutId}
              onChange={(event) => loadLayout(event.target.value)}
              className="rounded border border-slate-200 bg-white px-3 py-2 text-sm"
            >
              <option value="">New layout</option>
              {layouts.map((layout) => (
                <option key={layout._id} value={layout._id}>
                  {layout.name}
                </option>
              ))}
            </select>
            <button
              type="button"
              onClick={deleteCurrentLayout}
              disabled={!currentLayoutId && items.length === 0}
              className="inline-flex items-center gap-2 rounded border border-red-200 bg-white px-4 py-2 text-sm font-medium text-red-700 shadow-sm hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-50"
            >
              <Trash2 size={16} />
              Delete layout
            </button>
          </div>
        </div>

        {message && (
          <div className="rounded-lg border border-blue-100 bg-blue-50 px-4 py-2 text-sm text-blue-800">
            {message}
          </div>
        )}

        <div className="grid gap-4 lg:grid-cols-[260px_minmax(0,1fr)_300px]">
          <aside className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
            <div className="flex items-center justify-between gap-2">
              <h2 className="text-sm font-bold uppercase tracking-wide text-slate-700">SVG assets</h2>
              <label className="inline-flex cursor-pointer items-center gap-1 rounded bg-slate-900 px-3 py-1.5 text-xs font-medium text-white hover:bg-slate-800">
                <Upload size={14} />
                Upload
                <input type="file" accept=".svg,image/svg+xml" onChange={uploadSvg} className="hidden" />
              </label>
            </div>

            <div className="mt-4 grid grid-cols-2 gap-2">
              {assets.map((asset) => (
                <div
                  key={asset.id}
                  className="rounded-lg border border-slate-200 bg-slate-50 p-2 text-center text-sm font-semibold text-slate-800"
                >
                  <button
                    type="button"
                    onClick={() => addAssetToCanvas(asset)}
                    className="w-full rounded px-2 py-2 hover:bg-blue-50"
                    title={`Add ${asset.name}`}
                  >
                    {asset.kind === 'number' ? asset.name.replace('.svg', '') : asset.name}
                  </button>
                  {selectedItem && (
                    <button
                      type="button"
                      onClick={() => replaceSelectedVectorAsset(asset)}
                      className="mt-1 w-full rounded border border-blue-200 bg-white px-2 py-1 text-[11px] font-medium text-blue-700 hover:bg-blue-50"
                      title={`Replace selected vector with ${asset.name}`}
                    >
                      Replace
                    </button>
                  )}
                </div>
              ))}
            </div>
          </aside>

          <main className="overflow-auto rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
            <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
              <div>
                <h2 className="text-sm font-bold uppercase tracking-wide text-slate-700">Canvas</h2>
                <p className="text-xs text-slate-500">
                  {currentLayoutId ? layoutName : 'New unsaved layout'}
                </p>
              </div>
              <div className="flex flex-wrap items-center gap-2">
                <button
                  type="button"
                  onClick={() => saveLayout()}
                  className="inline-flex items-center gap-2 rounded bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-800"
                >
                  <Save size={16} />
                  Save layout
                </button>
                <button
                  type="button"
                  onClick={() => saveLayout({ saveAsNew: true })}
                  disabled={items.length === 0}
                  className="inline-flex items-center gap-2 rounded border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-700 shadow-sm hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-50"
                >
                  Save as new
                </button>
              </div>
            </div>
            <div
              style={{
                width: `${pageSize.width * scale}px`,
                height: `${pageSize.height * scale}px`,
                overflow: 'hidden',
                position: 'relative',
              }}
              className="mx-auto border border-slate-300 bg-white"
            >
              <Stage
                width={pageSize.width}
                height={pageSize.height}
                scaleX={scale}
                scaleY={scale}
                ref={stageRef}
                onMouseDown={(event) => {
                  if (event.target === event.target.getStage()) {
                    setSelectedItemId(null);
                  }
                }}
              >
                <Layer ref={layerRef}>
                  <Rect
                    width={pageSize.width}
                    height={pageSize.height}
                    fill="white"
                    onMouseDown={() => setSelectedItemId(null)}
                    onTouchStart={() => setSelectedItemId(null)}
                  />
                  {items.map((item) => (
                    <VectorCanvasItem
                      key={item.id}
                      item={item}
                      asset={assets.find((asset) => asset.id === item.assetId)}
                      selected={selectedItemId === item.id}
                      onSelect={setSelectedItemId}
                      onChange={updateItem}
                    />
                  ))}
                  <Transformer
                    ref={transformerRef}
                    rotateEnabled
                    keepRatio
                    boundBoxFunc={(oldBox, newBox) => {
                      if (newBox.width < 20 || newBox.height < 20) return oldBox;
                      return newBox;
                    }}
                  />
                </Layer>
              </Stage>
            </div>
          </main>

          <aside className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
            <h2 className="text-sm font-bold uppercase tracking-wide text-slate-700">
              Selected vector
            </h2>
            {!selectedItem ? (
              <p className="mt-3 text-sm text-slate-500">Select or add an SVG to edit it.</p>
            ) : (
              <div className="mt-4 space-y-4">
                <div>
                  <label className="text-xs font-semibold text-slate-600">Name</label>
                  <input
                    value={selectedItem.label || ''}
                    onChange={(event) => updateItem(selectedItem.id, { label: event.target.value })}
                    className="mt-1 w-full rounded border border-slate-200 px-3 py-2 text-sm"
                  />
                </div>

                <label className="text-xs font-semibold text-slate-600">
                  Replace vector
                  <select
                    value={selectedItem.assetId || ''}
                    onChange={(event) => {
                      const asset = assets.find((item) => item.id === event.target.value);
                      replaceSelectedVectorAsset(asset);
                    }}
                    className="mt-1 w-full rounded border border-slate-200 bg-white px-3 py-2 text-sm"
                  >
                    {assets.map((asset) => (
                      <option key={asset.id} value={asset.id}>
                        {asset.name}
                      </option>
                    ))}
                  </select>
                  <span className="mt-1 block text-[11px] font-normal text-slate-500">
                    Keeps the same position, size, rotation, and line width.
                  </span>
                </label>

                <div className="grid grid-cols-2 gap-2">
                  {[
                    ['x', 'X'],
                    ['y', 'Y'],
                    ['width', 'W'],
                    ['height', 'H'],
                  ].map(([key, label]) => (
                    <label key={key} className="text-xs font-semibold text-slate-600">
                      {label}
                      <input
                        type="number"
                        value={Math.round(selectedItem[key] || 0)}
                        onChange={(event) =>
                          updateItem(selectedItem.id, {
                            [key]: Number(event.target.value),
                            anchor: key === 'x' || key === 'y' ? 'custom' : selectedItem.anchor,
                          })
                        }
                        className="mt-1 w-full rounded border border-slate-200 px-2 py-1.5 text-sm"
                      />
                    </label>
                  ))}
                </div>

                <div>
                  <div className="mb-1 flex items-center justify-between text-xs font-semibold text-slate-600">
                    <span>Line width</span>
                    <span>{selectedItem.strokeWidth || 4}px</span>
                  </div>
                  <input
                    type="range"
                    min="1"
                    max="40"
                    step="1"
                    value={selectedItem.strokeWidth || 4}
                    onChange={(event) =>
                      updateItem(selectedItem.id, { strokeWidth: Number(event.target.value) })
                    }
                    className="w-full"
                  />
                </div>

                <label className="text-xs font-semibold text-slate-600">
                  Corner margin
                  <input
                    type="number"
                    value={selectedItem.margin ?? DEFAULT_MARGIN}
                    onChange={(event) => {
                      const margin = Number(event.target.value);
                      updateItem(selectedItem.id, { margin });
                      if (selectedItem.anchor && selectedItem.anchor !== 'custom') {
                        applyAnchor(selectedItem.anchor, margin);
                      }
                    }}
                    className="mt-1 w-full rounded border border-slate-200 px-3 py-2 text-sm"
                  />
                </label>

                <div className="grid grid-cols-2 gap-2">
                  <button
                    type="button"
                    onClick={() => applyAnchor('center')}
                    className="inline-flex items-center justify-center gap-1 rounded border border-slate-200 px-2 py-2 text-xs font-medium hover:bg-slate-50"
                  >
                    <AlignCenter size={14} />
                    Center
                  </button>
                  <button
                    type="button"
                    onClick={() => applyAnchor('center-x')}
                    className="inline-flex items-center justify-center gap-1 rounded border border-slate-200 px-2 py-2 text-xs font-medium hover:bg-slate-50"
                  >
                    <AlignHorizontalJustifyCenter size={14} />
                    Center X
                  </button>
                  <button
                    type="button"
                    onClick={() => applyAnchor('center-y')}
                    className="inline-flex items-center justify-center gap-1 rounded border border-slate-200 px-2 py-2 text-xs font-medium hover:bg-slate-50"
                  >
                    <AlignVerticalJustifyCenter size={14} />
                    Center Y
                  </button>
                  <button
                    type="button"
                    onClick={() => applyAnchor('top-right')}
                    className="inline-flex items-center justify-center gap-1 rounded border border-slate-200 px-2 py-2 text-xs font-medium hover:bg-slate-50"
                  >
                    <CornerUpRight size={14} />
                    Top right
                  </button>
                  <button
                    type="button"
                    onClick={() => applyAnchor('top-left')}
                    className="rounded border border-slate-200 px-2 py-2 text-xs font-medium hover:bg-slate-50"
                  >
                    Top left
                  </button>
                  <button
                    type="button"
                    onClick={() => applyAnchor('bottom-right')}
                    className="rounded border border-slate-200 px-2 py-2 text-xs font-medium hover:bg-slate-50"
                  >
                    Bottom right
                  </button>
                </div>

                <div className="rounded-lg bg-slate-50 px-3 py-2 text-xs text-slate-500">
                  Anchor: {selectedItem.anchor || 'custom'}
                  {selectedAsset ? ` · Asset: ${selectedAsset.name}` : ''}
                </div>

                <button
                  type="button"
                  onClick={deleteSelectedItem}
                  className="inline-flex w-full items-center justify-center gap-2 rounded border border-red-200 bg-white px-4 py-2 text-sm font-medium text-red-700 hover:bg-red-50"
                >
                  <Trash2 size={16} />
                  Remove vector
                </button>
              </div>
            )}
          </aside>
        </div>
      </div>
    </div>
  );
}

export default VectorLayoutEditor;
